import { render, staticRenderFns } from "./MainInput.vue?vue&type=template&id=5ed3c7d0&scoped=true"
import script from "./MainInput.vue?vue&type=script&lang=js"
export * from "./MainInput.vue?vue&type=script&lang=js"
import style0 from "./MainInput.vue?vue&type=style&index=0&id=5ed3c7d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed3c7d0",
  null
  
)

export default component.exports